module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/86c8f63128ac36ec23acc15f757267a8.png";